import { useMemo } from 'react';

import { Modal } from '@blockworks/ui';

import { ShareFeedbackModal } from './modal-types';
import type { QueryModalTypes } from './models';
import { useQueryModal } from './utils';

const getModalMap = (): Record<QueryModalTypes, any> => ({
    'share-feedback': ShareFeedbackModal,
});

function QueryModal() {
    const { closeModal, currentModal } = useQueryModal();
    const ModalType = useMemo(() => getModalMap(), [])[currentModal];

    return (
        <Modal open={!!ModalType} onClose={closeModal}>
            {ModalType ? <ModalType /> : null}
        </Modal>
    );
}

export { QueryModal };
